import { createFeatureSelector, createSelector } from '@ngrx/store'
import { ExpenseState } from '../state/expense.state'

const getExpenseState = createFeatureSelector<ExpenseState>('expense')

export const getExpenseReport = () =>
  createSelector(getExpenseState, state => {
    return state?.expenseReportList
  })

export const getExpenses = () =>
  createSelector(getExpenseState, state => {
    return state?.expenses
  })
